// GENERATED from backend/services/billMemory/core — do not edit; run backend/scripts/sync-bill-memory-core.js
/**
 * Bill Memory — quantities from memory (design D17). Informal units ("2 bundles", "1 katta",
 * "½", "pav", "dozen", "nos") are learned per vendor + item from what the user confirmed, and
 * applied only when the bill prints such a unit. A quantity printed in kg, g, L or ml is never
 * touched, and piece items stay with today's piece guard. Pure.
 */
const INFORMAL_UNITS = new Set(['bundle', 'bundles', 'bunch', 'katta', 'kattas', 'pav', 'paav', 'dozen', 'doz', 'dz', 'nos', 'half', '½', 'gaddi', 'tray', 'crate', 'bag', 'sack', 'box', 'case', 'carton', 'packet', 'pkt']);
const SINGULAR = { bundles: 'bundle', kattas: 'katta', paav: 'pav', doz: 'dozen', dz: 'dozen' };

/** "Bundles" → "bundle"; a weight, volume or piece unit → null. */
function informalUnitOf(unit) {
  const u = String(unit || '').trim().toLowerCase().replace(/\.$/, '');
  if (!INFORMAL_UNITS.has(u)) return null;
  return SINGULAR[u] || u;
}

/**
 * applyQuantityMemory(line, lesson) → { quantity, unit, note: { from, to }, trusted } | null
 * "3 bundles" with a learned "1 bundle = 250 g" → 750 g; trusted once confirmed on 2 stock-ins.
 */
function applyQuantityMemory(line, lesson) {
  const unit = informalUnitOf(line && line.unit);
  if (!unit || !lesson || !lesson.units) return null;
  const m = lesson.units[unit];
  const qty = Number(line.qty);
  if (!m || !(Number(m.base_qty) > 0) || !(qty > 0)) return null;
  const quantity = +(qty * Number(m.base_qty)).toFixed(3);
  const label = qty === 1 ? unit : `${unit}s`;
  return { quantity, unit: m.base_unit, note: { from: `${+qty} ${label}`, to: `${quantity} ${m.base_unit}` }, trusted: (m.confirmations || 0) >= 2 };
}

export { INFORMAL_UNITS, informalUnitOf, applyQuantityMemory };
